import React, { useState } from "react";
import { View, Text, TouchableOpacity, Image } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { AppImages } from "../../utility/AppImages";
import CretePrivateEventTooltip from "./CretePrivateEventTooltip";

const RevenueSplitComponent = ({
  organizerSplit,
  setOrganizerSplit,
  challengerSplit,
  setChallengerSplit,
  splitTooltip,
  setSplitTooltip,
}) => {
  const styles = useStyles();

  // Function to update splits while ensuring total is 100%
  const updateSplits = (newOrganizerSplit) => {
    // Clamp the value between 0 and 100
    const clampedOrganizerSplit = Math.max(0, Math.min(100, newOrganizerSplit));
    const newChallengerSplit = 100 - clampedOrganizerSplit;
    setOrganizerSplit(clampedOrganizerSplit);
    setChallengerSplit(newChallengerSplit);
  };
  const deviceSize = useDeviceSize();
  return (
    <View style={styles.mainContainer}>
      <View
        style={{
          flexDirection: "row",
          gap: 12,
          alignItems: "center",
        }}
      >
        <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>Revenue Split</Text>
        <TouchableOpacity onPress={() => setSplitTooltip(!splitTooltip)}>
          <Image
            source={AppImages.icInfoCircle}
            style={{
              height:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 17
                  : 20,
              width:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 17
                  : 20,
              resizeMode: "contain",
            }}
          />
        </TouchableOpacity>
        {splitTooltip && (
          <CretePrivateEventTooltip
            heading="💰 Ticket Sales Profit Distribution"
            content={
              <View>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                  ]}
                >
                  Decide how to split ticket revenue with your opponent. The
                  opponent can negotiate their share before accepting.
                </Text>{" "}
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                  ]}
                >
                  • Platform Fees: 10% (3% for subscribers)
                </Text>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                  ]}
                >
                  • Viewer Streaming Cost: Deducted from audience ticket sales
                </Text>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                  ]}
                >
                  The remaining profit is split based on your agreed terms.
                </Text>
              </View>
            }
            width={347}
            right={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 0
                : 468
            }
            bottom={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 34
                : -80
            }
            visible={splitTooltip}
            setVisible={setSplitTooltip}
          />
        )}
      </View>
      <View style={[styles.mainInputWrapper, { zIndex: -1 }]}>
        {/* Organizer Split */}
        <View style={styles.leftWrapper}>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12, styles.labelText]}>
            Kaller
          </Text>
          <View style={styles.inputContainer}>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_18, styles.inputText]}>
              {organizerSplit}
            </Text>
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 10 }}
            >
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_18,
                  { color: AppColors.gray_C4C4C4 },
                ]}
              >
                %
              </Text>
              <View style={styles.arrowContainer}>
                <TouchableOpacity
                  onPress={() => updateSplits(organizerSplit + 1)}
                  disabled={organizerSplit >= 100}
                >
                  <Image
                    source={AppImages.icnUpPrice}
                    style={{
                      width: 14,
                      height: 14,
                      resizeMode: "contain",
                    }}
                  />
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => updateSplits(organizerSplit - 1)}
                  disabled={organizerSplit <= 0}
                >
                  <Image
                    source={AppImages.icnDownPrice}
                    style={{
                      width: 14,
                      height: 14,
                      resizeMode: "contain",
                    }}
                  />
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>

        {/* Challenger Split */}
        <View style={styles.leftWrapper}>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12, styles.labelText]}>
            Challengers (%)
          </Text>
          <View style={styles.inputContainer}>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_18, styles.inputText]}>
              {challengerSplit}
            </Text>
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 10 }}
            >
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_18,
                  { color: AppColors.gray_C4C4C4 },
                ]}
              >
                %
              </Text>
              <View style={styles.arrowContainer}>
                <TouchableOpacity
                  onPress={() => updateSplits(organizerSplit - 1)}
                  disabled={challengerSplit >= 100}
                >
                  <Image
                    source={AppImages.icnUpPrice}
                    style={{
                      width: 14,
                      height: 14,
                      resizeMode: "contain",
                    }}
                  />
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => updateSplits(organizerSplit + 1)}
                  disabled={challengerSplit <= 0}
                >
                  <Image
                    source={AppImages.icnDownPrice}
                    style={{
                      width: 14,
                      height: 14,
                      resizeMode: "contain",
                    }}
                  />
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </View>

      {/* Footer Note */}
      {/* <View style={styles.footerContainer}>
        <View style={styles.circleIcon} />
        <Text style={[AppFontStyle.REGULAR_ANYBODY_12, styles.footerText]}>
          ALL-OR-NOTHING ARENA (WINNER TAKES ALL GIFTS)
        </Text>
      </View> */}
    </View>
  );
};

export default RevenueSplitComponent;

const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      flexDirection: "column",
      gap: 12,
    },
    mainInputWrapper: {
      flexDirection: "row",
      gap: 25,
    },
    leftWrapper: {
      flex: 0.5,
      flexDirection: "column",
      gap: 8,
    },
    labelText: {
      color: AppColors.gray_C4C4C4,
    },
    inputContainer: {
      flexDirection: "row",
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      borderRadius: 10,
      borderWidth: 1,
      paddingHorizontal: 12,
      paddingVertical: 8,
      alignItems: "center",
      justifyContent: "space-between",
    },
    inputText: {
      color: AppColors.gray_C4C4C4,
    },
    arrowContainer: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: 10,
    },
    footerContainer: {
      flexDirection: "row",
      alignItems: "center",
      gap: 8,
      marginTop: 8,
    },
    circleIcon: {
      width: 12,
      height: 12,
      borderRadius: 6,
      backgroundColor: AppColors.gray_C4C4C4,
    },
    footerText: {
      color: AppColors.white,
      textTransform: "uppercase",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      mainInputWrapper: {
        flexDirection: "row",
        gap: 25,
      },
      leftWrapper: {
        flex: 0.5,
        flexDirection: "column",
        gap: 8,
      },
    },
    [DEVICE_SIZES.MD]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 8,
      },
    },
    [DEVICE_SIZES.SM]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 8,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 8,
      },
    },
  }
);
